module.exports = __webpack_public_path__ + "static/img/cardBack.c51a7b98.png";